import { render } from "./CustomTestComponent.vue?vue&type=template&id=db1aaebc"
import script from "./CustomTestComponent.vue?vue&type=script&lang=js"
export * from "./CustomTestComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__